export default "<p>labelbarcode works!</p>\n"